import { Image as ChakraImage } from '@chakra-ui/react';

// eslint-disable-next-line import/prefer-default-export
export const Image = ChakraImage;
